import React from 'react';

function PdfIcon() {
  return (
    <svg
      width="100"
      height="101"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 93.9619H19.25V100.212H13C5.96875 100.212 0.5 94.7432 0.5 87.7119V12.7119C0.5 5.87598 5.96875 0.211914 13 0.211914H43.4688C45.8125 0.211914 48.3516 1.38379 50.1094 3.1416L72.5703 25.6025C74.3281 27.3604 75.5 29.8994 75.5 32.2432V56.4619H69.25V37.7119H47.375C42.1016 37.7119 38 33.6104 38 28.3369V6.46191H13C9.48438 6.46191 6.75 9.3916 6.75 12.7119V87.7119C6.75 91.2275 9.48438 93.9619 13 93.9619ZM69.0547 31.4619C68.8594 31.0713 68.6641 30.4854 68.2734 30.0947L45.6172 7.43848C45.2266 7.04785 44.6406 6.85254 44.25 6.65723V28.3369C44.25 30.0947 45.6172 31.4619 47.375 31.4619H69.0547Z"
        fill="#6754E2"
      />
      <path
        d="M36.4098 84.0826H40.7172C43.7828 84.0826 45.141 82.5691 45.141 80.1632C45.141 77.6797 43.7828 76.205 40.7172 76.205H36.4098V84.0826ZM50.729 80.1632C50.729 84.2766 47.935 88.4676 40.95 88.4676H36.4098V98.8674H30.977V71.7812H40.95C47.4693 71.7812 50.729 75.4678 50.729 80.1632Z"
        fill="#C9C2F5"
      />
      <path
        d="M64.0547 71.7812C72.7083 71.7812 78.3351 77.1364 78.3351 85.3631C78.3351 93.5511 72.7083 98.8674 64.0547 98.8674H54.5862V71.7812H64.0547ZM60.019 94.2496H63.8607C69.5651 94.2496 72.7859 90.9899 72.7859 85.3631C72.7859 79.7363 69.5651 76.3603 63.8607 76.3603H60.019V94.2496Z"
        fill="#C9C2F5"
      />
      <path
        d="M82.4018 98.8674V71.7812H99.127V76.1662H87.8346V83.1124H96.4882V87.4198H87.8346V98.8674H82.4018Z"
        fill="#C9C2F5"
      />
    </svg>
  );
}
export default PdfIcon;
